"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f224 = void 0;
exports.f224 = {
    "àhàn": [
        188
    ],
    "àbéélé": [
        1265
    ],
    "ànda": [
        3462
    ],
    "àshwəŋnə̀ pìnyinə": [
        6248
    ],
    "àshwəŋnə̀": [
        6248
    ],
    "àmzírív": [
        9058
    ]
};
